import HowToVideo from './HowToVideo';

export default HowToVideo;
